import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Table, Input, Tooltip, Space, Tag } from "antd";
import { FileTextOutlined, SearchOutlined, ExceptionOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../services/http";
import dayjs from "dayjs";

export const AvisoFerias = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // FILTRO
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarAvisosFerias();
  }, []);

  // LISTAR
  const listarAvisosFerias = async () => {
    setLoading(true);
    const api = await http("get", `v1/aviso_ferias/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      key: "prgdat",
      title: "Data",
      render: (_, e) => dayjs(e.prgdat).format("DD/MM/YYYY"),
      sorter: (a, b) =>
        dayjs(a.prgdat).format("DD/MM/YYYY")?.toString()?.localeCompare(dayjs(b.prgdat).format("DD/MM/YYYY")),
    },
    {
      dataIndex: "status_confirmacao",
      title: "Status Confirmação",
      render: (_, e) =>
        e.status_confirmacao === 1 ? <Tag color="green">Confirmado</Tag> : <Tag color="red">Pendente</Tag>,
      sorter: (a, b) => a.status_confirmacao?.toString()?.localeCompare(b.status_confirmacao?.toString()),
    },
    {
      key: "status",
      title: "Status do Documento",
      render: (_, e) => (e.status === 1 ? <Tag color="green">Ativo</Tag> : <Tag color="red">Inativo</Tag>),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      key: "acoes",
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Button
            loading={loading}
            onClick={() => navigate(`/aviso-ferias/detalhes/${e.id}`)}
            icon={<FileTextOutlined />}>
            Visualizar
          </Button>
        </Space.Compact>
      ),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter((val) =>
      dayjs(val.prgdat).format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Documentos" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Avisos de Férias"
              loading={loading}
              subtitle={"Consultar meus avisos de férias"}
              icon={<ExceptionOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                rowKey="id"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
